import constants from "./constants";
import createAction from "sagas/createAction";
import { createPromiseAction } from "@adobe/redux-saga-promise";

const actions = {
  GetPerformanceList: (cusId, date, view) => createAction(constants.GET_PERFORMANCE_LIST, { cusId, date, view }),
  GetPerformanceVersus: (cusId, baseDate, compareDate, view) =>
    createAction(constants.GET_PERFORMANCE_VERSUS, { cusId, baseDate, compareDate, view }),

  GetFBDashboardList: (ads_account_id, date_preset) =>
    createAction(constants.GET_FBDASHBOARD_LIST, { ads_account_id, date_preset }),
  GetFBReportList: createPromiseAction(constants.GET_FBREPORT_LIST),
  GetFBGraph: createPromiseAction(constants.GET_FBGRAPH_LIST),

  GetGdashboardList: (ads_account_id, date_preset) =>
    createAction(constants.GET_GDASHBOARD_LIST, { ads_account_id, date_preset }),
  GetGReportList: createPromiseAction(constants.GET_GREPORT_LIST),
  GetGGraph: createPromiseAction(constants.GET_GGRAPH_LIST),
};

export default actions;
